import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseStructuredSchema } from './shared/base-structured.schema';
export const otherSchema = baseStructuredSchema.safeExtend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Other),
    // @ts-ignore
    fund_id: z.number().int().optional().nullable(),
});
